import React from 'react';
import * as styles from './index.module.less';
import { companyLogoList } from '../../constants';

const companyLogoListA = companyLogoList.slice(0, 12);
const companyLogoListB = companyLogoList.slice(12);

interface IProps {
  className?: string;
}

const CompanyLogoList = ({ className = '' }: IProps) => {
  return (
    <div className={`${styles.company_logos_container} ${className}`}>
      <div className={styles.company_logos}>
        <div className={styles.logo_container_wrapper}>
          <div className={styles.logo_container}>
            {[...companyLogoListA, ...companyLogoListA].map((item, index) => {
              return (
                <div key={index} className={styles.company_logo_item}>
                  <img src={item.src} alt={item.alt} />
                </div>
              );
            })}
          </div>
          <div className={styles.logo_container}>
            {[...companyLogoListA, ...companyLogoListA].map((item, index) => {
              return (
                <div key={index} className={styles.company_logo_item}>
                  <img src={item.src} alt={item.alt} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className={styles.company_logos}>
        <div className={styles.logo_container_wrapper}>
          <div className={styles.logo_container}>
            {[...companyLogoListB, ...companyLogoListB].map((item, index) => {
              return (
                <div key={index} className={styles.company_logo_item}>
                  <img src={item.src} alt={item.alt} />
                </div>
              );
            })}
          </div>
          <div className={styles.logo_container}>
            {[...companyLogoListB, ...companyLogoListB].map((item, index) => {
              return (
                <div key={index} className={styles.company_logo_item}>
                  <img src={item.src} alt={item.alt} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CompanyLogoList;
